import React from 'react';
import Bem from 'bemHelper';
import get from 'lodash/get';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';
import Link from 'components/link';
import Button from 'components/button';
import linksBildControl from 'src-sites/bildcontrol/links';
import linksBild from 'src-sites/bild/links';
import { renderCommonIconAndItem, renderSimpleLink } from 'src-sites/bild/section-project/render-common';
import {
  reliabilityIndexComplex,
  renderReliabilityDateActualize
} from 'src-sites/bild/section-project/reliability-index';

const bemClasses = new Bem('project');

export default function renderRightColumn(project) {
  const { i18n } = this;
  const { advanced_info = {}, display_name, date_life, ...rest } = project;
  const { complex_forums } = advanced_info;
  const { status_ready } = rest;

  return (
    <div {...bemClasses('block', 'info')}>
      <div {...bemClasses('blockContent')}>
        {renderReliability.call(this, rest)}
      </div>
      <div {...bemClasses('itemGroup', 'iconText')}>
        {status_ready && renderCommonIconAndItem.call(
          this,
          bemClasses,
          iconTypes.discussion,
          complex_forums,
          ['complex_forums'],
          { forum: true }
        )}
        {renderSiteLink.call(null, '', i18n('apartmentsInComplex', { placeholder: display_name }), linksBild.sectionLanding, rest, true, true, iconTypes.stock)}
      </div>
    </div>
  );
}

function renderReliability(rest) {
  const { i18n } = this;
  const { points, status_ready, type } = rest;

  return (
    <div {...bemClasses('blockReliability', { ready: status_ready })}>
      <div {...bemClasses('top')}>
        <Row {...bemClasses('row')}>
          {!status_ready &&
            <Col {...bemClasses('col', 'topic')} allPr={0}>
              <div>
                <span {...bemClasses('text', 'topic')} children={i18n('newBuildingReliabilityIndex')} />
              </div>
            </Col>
          }
          <Col {...bemClasses('col', 'points')} allAuto allPr={0}>
            {reliabilityIndexComplex.call(this, bemClasses, points, type, status_ready)}
          </Col>
        </Row>
        {!status_ready && renderReliabilityDateActualize.call(this, bemClasses, rest)}
        {/*
        {reliability_date_user_edit && reliability_to_publish &&
          renderDate.call(null, 'Последние изменения в отчёте', reliability_date_user_edit)
        }
        */}
      </div>
      {!status_ready &&
        <div {...bemClasses('bottom')}>
          <Button
            {...bemClasses('btn', 'toReport')}
            title={`${i18n('get')}${i18n('actualDetailedReport')}`}
            onClick={this.scrollTo}
            customRenderer
          >
            <span {...bemClasses('btnContent')}>
              <span {...bemClasses('after')} />
              <span
                {...bemClasses('text', 'link')}
                children={`${i18n('get')}${i18n('actualDetailedReport')}`}
              />
            </span>
          </Button>
          <Link
            {...bemClasses('link', 'toHowWeCalculate')}
            builder={linksBildControl.sectionHowWeCalculateScore}
            builderProps={rest}
            external
          >
            <span {...bemClasses('linkContent')}>
              <span
                {...bemClasses('text', 'link')}
                children={i18n('howWeCalculateScore')}
              />
            </span>
          </Link>
        </div>
      }
    </div>
  );
}

function renderSiteLink(
  url, text, builder, builderProps, blank, noRedirector, icon = iconTypes.planet
) {
  if ((!url && !builder) || !text) return null;
  return (
    <div {...bemClasses('item', 'row')}>
      <span {...bemClasses('text', 'icon')}>
        <Icon {...bemClasses('icon')} type={icon} />
      </span>
      <span {...bemClasses('text', 'colRight')}>
        {renderSimpleLink(
          bemClasses,
          { url, text, builder, builderProps, blank, noRedirector },
          true,
          { site: true }
        )}
      </span>
    </div>
  );
}
